"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _fileTypeIcons = require("../V2/Shared/fileTypeIcons");

var Attachments = function Attachments(_ref) {
  var attachments = _ref.attachments,
      attachmentCdn = _ref.attachmentCdn;
  var attachmentsPerRow = 4;
  var gridClass = "grid--".concat(12 / attachmentsPerRow);

  var groupedAttachmentArray = function groupedAttachmentArray(array, size) {
    var result = [];

    for (var i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }

    return result;
  };

  var attachmentGroups = groupedAttachmentArray(attachments, attachmentsPerRow);

  var getBgImageUrlForImage = function getBgImageUrlForImage(attachment, attachmentCdn) {
    var bgImageUrl = attachment.short_thumb_url ? attachment.short_thumb_url : attachment.short_url;
    var isFullUrl = bgImageUrl.startsWith('http');
    return isFullUrl ? bgImageUrl : attachmentCdn + bgImageUrl;
  };

  function renderAttachment(attachment, attachmentCdn) {
    var isImage = attachment.type === 'image' || attachment.type === 'video';
    var mfpClass = isImage ? "mfp-".concat(attachment.type) : 'file-attachment';
    var bgImageUrl = isImage ? getBgImageUrlForImage(attachment, attachmentCdn) : undefined;
    var hrefImageLink = attachment.source.startsWith('http') ? attachment.source : "".concat(attachmentCdn).concat(attachment.source);
    var FileTypeIcon = (0, _fileTypeIcons.getFileTypeIcon)(attachment.type);
    return (0, _preact.h)("div", {
      className: "group__item ".concat(gridClass, " attachment__item"),
      key: attachment.id
    }, (0, _preact.h)("a", {
      className: "attachment__link attachment__link--".concat(attachment.type, " ").concat(mfpClass),
      style: bgImageUrl ? {
        backgroundImage: "url(".concat(bgImageUrl, ")")
      } : undefined,
      href: (0, _absoluteUrlRuntime.resolveUrl)(isImage ? "".concat(hrefImageLink) : "".concat(attachment.source)),
      target: "_blank",
      rel: "noreferrer"
    }, attachment.type === 'video' && (0, _preact.h)("span", {
      className: "icon icon--play"
    }), !isImage && (0, _preact.h)("div", null, FileTypeIcon && (0, _preact.h)(FileTypeIcon, {
      className: "icon--file"
    }), (0, _preact.h)("span", {
      className: "file-attachment--filename"
    }, attachment.file_original_name))));
  }

  return (0, _preact.h)("div", {
    className: "group attachments"
  }, (0, _preact.h)("h5", null, (0, _preact.h)("strong", null, attachments.length, " Attachments")), (0, _preact.h)("div", {
    "data-helper": "gallery",
    "data-data": "{\"delegate\": \"a.attachment__link--image\"}"
  }, attachmentGroups.map(function (group) {
    return (0, _preact.h)("div", {
      key: "group-".concat(group[0].id),
      className: "group__row"
    }, group.map(function (attachment) {
      return renderAttachment(attachment, attachmentCdn);
    }));
  })));
};

var _default = Attachments;
exports.default = _default;